import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise'
import type { IReportedComment, IReportedPost } from '~/types/report'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { badgeColDef, dateColDef, textColDef } from '~/utils/table'

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'text',
  }),
  badgeColDef(BadgeCellRenderer, {
    field: 'status',
    filterValueGetter: ({ data }: ValueGetterParams<IReportedComment>): string | null | undefined => data?.status,
    headerName: 'Status',
    resizable: false,
    suppressMovable: true,
    suppressNavigable: true,
    valueGetter: ({
      data,
    }: ValueGetterParams<IReportedComment>): {
      data: { id: string; name: string }[]
      maxItems?: number
      type: string
    } | null => {
      if (data) {
        const { status } = data

        return {
          data:
            [
              {
                id: status,
                name: status,
              },
            ] || [],
          type: 'default',
        }
      }

      return null
    },
  }),
  badgeColDef(BadgeCellRenderer, {
    field: 'tagged_profiles_ids',
    filterValueGetter: ({ data }: ValueGetterParams<IReportedComment>): string[] | null | undefined =>
      data?.tagged_profiles_ids,
    headerName: 'Tagged Profiles IDs',
    resizable: false,
    suppressMovable: true,
    suppressNavigable: true,
    valueGetter: ({
      data,
    }: ValueGetterParams<IReportedComment>): {
      data: { id: string; name: string }[]
      type: string
    } | null => {
      if (data) {
        const { tagged_profiles_ids } = data

        return {
          data:
            tagged_profiles_ids.map((id) => ({
              id,
              name: id,
            })) || [],
          type: 'default',
        }
      }

      return null
    },
  }),
  dateColDef({
    field: 'updated_at',
    headerName: 'Update Date',
    resizable: false,
    valueGetter: ({ data }: ValueGetterParams<IReportedPost, number | null>) =>
      data && data.updated_at && data.updated_at * 1000000,
  }),
]

export default columns
